import { Button } from "components/Button/Button"
import { CheckableButton } from "components/CheckableButton/CheckableButton"
import { Toast } from "components/ToastShow/ToastAlert"
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext"
import React, { useContext, useEffect, useState } from "react"
import { MessageType, OrganizationType } from "types/enum"
import { getWidgetList } from "../../profile/api"
import { Loading } from "components/Loading/loading"

interface props {
    setShowWidgetForm: React.Dispatch<React.SetStateAction<boolean>>
}

export const WidgetForm = ({setShowWidgetForm}: props) => {
    const layoutContext = useContext(LayoutContext);
    const savedWidgets = JSON.parse(localStorage.getItem('widgetList') as string) 
    const [checkboxList, setCheckboxList] = useState<any>();
    const [loading,setLoading]=useState(false)

   

    const handleSubmit = (event) => {
        event.preventDefault()
        const data:any = [ ]
        checkboxList.map(item=>{
            if(event.target[item]?.checked ){
                data.push(item)            
            }
            

        })
        let obj = {}
        checkboxList.map(item=>{
            if(item!=undefined){
                obj[item] = data.includes(item)

            }
        })

        localStorage.setItem('widgetList', JSON.stringify(obj))
        // Toast('ویجت ها ثبت شد', 'success')
        Toast('ویجت ها ثبت شد', MessageType.success)

        setShowWidgetForm(false)
        layoutContext.setWidgetFormFlag(!layoutContext.widgetFormFlag)
    }


    async function getWidgetListAsync() {
        setLoading(false)
        try {
          let obj = {}
          const res = await  getWidgetList(layoutContext?.currentUserPosition?.OrganizationType == OrganizationType.Customers)
          let list:any = []
          setCheckboxList(res.Data)

        } catch (error) {
          
        }
        setLoading(true)

      }
    
    useEffect(() => {    
          getWidgetListAsync()
    }, [ ]);
    
    

    return (
        <form onSubmit={handleSubmit}>
       { loading ?    <div className="card p-2">
                <div className="row mt-3">
                    {
                       checkboxList && checkboxList.map((item,index) => (
                            <div className="col-2" key={index}>
                                <CheckableButton 
                                    labelText={item}
                                    type="checkbox"
                                    inputName={item}
                                    defaultValue={item}
                                    defaultChecked={savedWidgets[item]}
                                />
                            </div>
                        ))
                    }
                </div>
                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <Button btnType="submit" value={'submit'} />
                    </div>
                </div>
            </div>:<Loading/>}
        </form>
    )
}